import { Stack, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BaseNodeDTO } from "../../../../../../../../../../../../datasources/api-client/data-contracts";
import { NodeSearchMap } from "../../NodeSearchMap";

type SearchCodeMapProps = {
	id: string;
	code: string;
	onChange: (value: string) => void;
	loading: boolean;
	nodes: BaseNodeDTO[];
	onSelectNode: (node: BaseNodeDTO) => void;
};
export const SearchCodeMap = ({ id, code, onChange, loading, nodes, onSelectNode }: SearchCodeMapProps) => {
	const { t } = useTranslation("dataCollection");
	return (
		<Stack spacing={2}>
			<TextField
				id={id}
				name={id}
				label={t("detail/code")}
				value={code}
				onChange={(event) => onChange(event.target.value)}
				disabled={loading}
				size="small"
				autoComplete="off"
				sx={{ width: 170 }}
			/>{" "}
			<NodeSearchMap nodes={nodes} loading={loading} onSelectNode={onSelectNode} />
		</Stack>
	);
};
